<template>
  <header>
    <app-header-navigation :showNavigation="showNavigation"></app-header-navigation>
    <app-header-search @toggleNavigation="toggleNavigation"></app-header-search>
  </header>
</template>

<script>
import AppHeaderNavigation from './AppHeaderNavigation.vue';
import AppHeaderSearch from './AppHeaderSearch.vue';

export default {
  name: 'app-header',

  components: {
    AppHeaderNavigation,
    AppHeaderSearch,
  },

  data() {
    return {
      showNavigation: undefined
    };
  },

  methods: {
    toggleNavigation() {
      this.showNavigation = !this.showNavigation;
    }
  }
};
</script>

<style>
header {
  display: flex;
  flex-direction: column;
}
.header-container {
  display: flex;
  align-items: center;
}

@media (max-width: 1023px) {
  header {
    flex-direction: column-reverse;
  }

  .header-container {
    justify-content: space-between;
  }
}
</style>
